import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import paywallsActions from 'redux/actions/paywallsActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import upgradeSourceTypes from 'helpers/enums/metrics/upgradeSourceTypes'

import MaxPresentationSizeReachedUpgradeConfirm from 'views/paywalls/confirms/paywalls_max_presentation_size_reached_upgrade'
import MaxPresentationSizeReachedContactConfirm from 'views/paywalls/confirms/paywalls_max_presentation_size_reached_contact'
import maxPresentationSizeReachedSelector from 'redux/selectors/user/user_max_presentation_size_reached_selector'

class MaxPresentationSizeReachedContainer extends PureComponent {

	upgradeSelected = () => {
		this.props.actions.upgradeSelected(this.props.upgradeSource)
	}

	render() {
		if (this.props.shouldShowContact) {
			return (
				<MaxPresentationSizeReachedContactConfirm
					maxSizeOfPresentations={this.props.maxSizeOfPresentations}
					closeConfirmSelected={this.props.actions.closeConfirmSelected}
					acceptConfirmSelected={this.props.actions.acceptConfirmSelected}
				/>
			)
		} else {
			return (
				<MaxPresentationSizeReachedUpgradeConfirm
					maxSizeOfPresentations={this.props.maxSizeOfPresentations}
					closeConfirmSelected={this.props.actions.closeConfirmSelected}
					upgradeSelected={this.upgradeSelected}
				/>
			)
		}
	}
}

function mapStateToProps(state) {
	return maxPresentationSizeReachedSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		upgradeSelected: paywallsActions.presentationSizeExceededConfirmUpgradeSelected,
		closeConfirmSelected: paywallsActions.presentationSizeExceededConfirmCloseSelected,
		acceptConfirmSelected: paywallsActions.presentationSizeExceededConfirmAcceptSelected,
	}, dispatch)
}

MaxPresentationSizeReachedContainer.propTypes = {
	maxSizeOfPresentations: PropTypes.string,
	shouldShowContact: PropTypes.bool,
	actions: PropTypes.shape({
		upgradeSelected: PropTypes.func.isRequired,
		closeConfirmSelected: PropTypes.func.isRequired,
		acceptConfirmSelected: PropTypes.func.isRequired,
	}),
	upgradeSource: PropTypes.oneOf(
		Object.values(upgradeSourceTypes)
	).isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	MaxPresentationSizeReachedContainer
)

export { MaxPresentationSizeReachedContainer }
